import { getStockStatusChecks, type StockInfo } from '../../../../../product/index';

import {
  ProductStock,
  ProductStockList,
  type ProductStockVariant,
} from '@vs-shop/commerce-ui/productStock';

import { isCzChannel } from '../../../../../config/channel';

import ProductStockItem from './ProductStockItem/ProductStockItem';

import { Warehouse } from '../../../../../enum/warehouse';

type Props = {
  stock: StockInfo;
  variant: ProductStockVariant;
};

/**
 * rcprofi's availability rows.
 *
 * Which rows exist is this tenant's: the e-shop always answers, and the two
 * shop floors answer only on the Czech channel and only while anything is left
 * at all. How the block looks is the appearance the placement asks for; the
 * rows themselves are `@vs-shop/commerce-ui`'s.
 */
export default function ProductInStock({ stock, variant }: Props) {
  const { eshop, localWarehouse, status } = stock;

  const { isSoldOut } = getStockStatusChecks(stock.status);

  const isChannelCZ = isCzChannel();

  const warehousePce = localWarehouse.find((warehouse) => warehouse.type === Warehouse.PCE);
  const warehouseCru = localWarehouse.find((warehouse) => warehouse.type === Warehouse.CRU);

  const eshopDispatchDate = eshop.dispatchDate ?? null;

  return (
    <ProductStock variant={variant}>
      <ProductStockList variant={variant}>
        {/* E-SHOP */}
        <ProductStockItem
          isEshop={true}
          date={eshopDispatchDate}
          quantity={eshop.maxOrderable}
          stockStatus={status}
        />

        {/* WAREHOUSES - only shown if not completely out of stock */}
        {isChannelCZ && !isSoldOut && (
          <>
            <ProductStockItem
              isEshop={false}
              warehouseType={Warehouse.PCE}
              date={warehousePce?.dispatchDate ?? null}
              quantity={warehousePce?.quantity ?? 0}
              stockStatus={status}
            />
            <ProductStockItem
              isEshop={false}
              warehouseType={Warehouse.CRU}
              date={warehouseCru?.dispatchDate ?? null}
              quantity={warehouseCru?.quantity ?? 0}
              stockStatus={status}
            />
          </>
        )}
      </ProductStockList>
    </ProductStock>
  );
}
